const Layout = () => import("@/views/Layout.vue");
const Home = () => import("@/views/Home");
const AboutMe = () => import("@/views/AboutMe");
const Projects = () => import("@/views/Projects");
const ContactMe = () => import("@/views/ContactMe");

export const HOMEPAGE = 'Home';
export const ABOUT_ME = 'AboutMe';
export const PROJECTS = 'Projects';
export const CONTACT_ME = 'ContactMe';
export const WORK = 'Work';
export const RESUME = 'Resume';

export const home = {
  path: "",
  // redirect: 'home',
  component: Layout,
  children: [
    {
      path: '',
      name: HOMEPAGE,
      component: Home
    },
    {
      path: 'about-me',
      name: ABOUT_ME,
      component: AboutMe
    },
    {
      path: 'projects',
      name: PROJECTS,
      component: Projects
    },
    {
      path: 'contact-me',
      name: CONTACT_ME,
      component: ContactMe
    }
    // {
    //   path: 'work',
    //   name: WORK,
    //   component: Work
    // },
    // {
    //   path: 'resume',
    //   name: RESUME,
    //   component: Resume
    // }
  ]
};
